import React, { createContext, useContext } from "react";
import { useState } from "react";

const SessionContext = createContext();
const SessionProvider = (props) => {
  const [classroom, setClassroom] = useState(null);
  const [contentId, setContentId] = useState(1);
  const [videoSelect, setVideoSelect] = useState();
  const [classesList, setClassesList] = useState();
  const [sideBar, setsideBar] = useState(false);
  const [contentInfo, setContentInfo] = useState([]);
  const [sessionList, setSessionList] = useState([]);
  const [sessionPervPrecense, setSessionPervPrecense] = useState();
  const [isReady, setIsReady] = useState(false);


  return (
    <SessionContext.Provider
      value={{
        classroom, setClassroom,
        sessionPervPrecense,
        setSessionPervPrecense,
        sessionList,
        setSessionList,
        sideBar,
        setsideBar,
        videoSelect,
        setVideoSelect,
        contentId,
        setContentId,
        classesList,
        setClassesList,
        contentInfo,
        setContentInfo,
        isReady, setIsReady
      }}
    >
      {props.children}
    </SessionContext.Provider>
  );
};
const useSession = () => useContext(SessionContext);
export { useSession, SessionProvider };
